import styled from 'styled-components';

export const SC_TooltipSlider = styled.div`
    width: 240px;
    height: 50px;
    background-color: var(--alabaster);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
        font-size: 12px !important;
        margin: 0 0!important;
        line-height: 18px;
        color: var(--dim-gray);
    }

    .link{
        color: var(--chateau-green);
        cursor: pointer;
        font-weight: bold;
    }
`